<template>
  <div>
    <span v-if="data.column.field === 'insertDateTime'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          {{ data.formattedRow.insertDateTime }}
        </span>
        <span
          v-if="data.row.statusId === 1 || data.row.statusId === 2"
          class="d-flex"
        >
          <b-button
            v-if="data.row.statusId === 1"
            v-b-modal.approve-reject-withdraw-modal
            variant="link"
            class="p-0"
            @click="editWithdrawRequest(data.row, type = 1)"
          >
            <GjIcon
              :key="`check-${data.row.id}`"
              name="Check"
              class="text-success"
            />
          </b-button>
          <b-button
            v-if="data.row.statusId === 2"
            v-b-modal.approve-reject-withdraw-modal
            v-b-tooltip.hover="$tk('ClientPortal.Admin.Paid')"
            variant="link"
            class="p-0"
            @click="editWithdrawRequest(data.row, type = 2)"
          >
            <GjIcon
              :key="`pay-${data.row.id}`"
              name="PaymentAlt"
              class="text-primary"
            />
          </b-button>
          <b-button
            v-if="data.row.statusId === 1"
            v-b-modal.approve-reject-withdraw-modal
            variant="link"
            class="p-0"
            @click="editWithdrawRequest(data.row, type = 3)"
          >
            <GjIcon
              :key="`close-${data.row.id}`"
              name="Close"
              class="text-danger"
            />
          </b-button>
        </span>
      </div>
    </span>

    <span
      v-else-if="data.column.field === 'accountName'"
      class="d-flex text-primary"
    >
      <b-link
        :to="'/'+data.row.redirectUrlSPA"
      >
        {{ data.formattedRow.accountName }}
      </b-link>
    </span>

    <span
      v-else-if="data.column.field === 'status'"
      class="d-flex text-primary"
    >
      <span
        :class="getCustomClass(data.row.statusId)"
      >
        {{ data.formattedRow.status }}
      </span>
    </span>

    <span
      v-else-if="data.column.field === 'filePath'"
      class="d-flex"
    >
      <span v-if="data.formattedRow.filePath != null">
        <b-link
          :href="data.formattedRow.filePath"
          target="_blank"
        >
          {{ $tk('ClientPortal.Admin.ClickToViewFile') }}
        </b-link>
      </span>
      <span v-else>
        {{ $tk('ClientPortal.Admin.NoFile') }}
      </span>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {

  components: {
    GjIcon,

  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const editWithdrawRequest = (data, type) => store.commit('SET_WITHDRAW_REQUEST', { data, type })
    const getCustomClass = statusId => {
      const classOptions = {
        1: 'text-warning',
        2: 'text-success',
        3: 'text-danger',
        4: 'text-primary',
      }
      return classOptions[statusId]
    }
    return { editWithdrawRequest, getCustomClass }
  },
}
</script>
